import { normalize, denormalize, schema } from 'normalizr'
import {
  ETS_STATUS_SORT_ORDER,
  APPROVAL_REQUEST_CONFIG,
  ARTYPE_NONSTOCKEDSSD,
  ARTYPE_ANCILLARYMATERIALS,
  ARTYPE_EXCEPTIONTESTING,
  ARTYPE_ORDERSAFTERDEADLINE,
  ARTYPE_RESHIPMENTS,
  SPECIAL_ORDER_TYPE_SECURE,
  ARTYPE_OFFCYCLETESTING,
} from '../constants/ApprovalRequestConstants'
import { sortColumnByKey } from './sort'

const requestStatusStrategy = entity => ({
  ...entity,
  fetching: entity.fetching || false,
  fetched: entity.fetched || false,
  error: entity.error || null,
})

// const sectionSchema     = new schema.Entity('sections', {}, { idAttribute: 'sectionId', processStrategy: requestStatusStrategy })
// const enrollmentSchema  = new schema.Entity('sections', {}, {
//   idAttribute: 'enrollmentId',
//   processStrategy: entity => ({
//     isInactiveEnrollment: Boolean(entity.inactiveReason),
//     isDroppedWithCost: entity.inactiveReason === 'D' && entity.droppedWithCost === true,
//     isTransferred: entity.inactiveReason === 'T',
//     isMerged: entity.inactiveReason === 'M',
//     noEndOfCourseExam: entity.noEndOfCourseExam === undefined || entity.noEndOfCourseExam === null ? false : entity.noEndOfCourseExam,
//     notTakingExamReasonCd: entity.notTakingExamReasonCd === undefined ? null : entity.notTakingExamReasonCd,
//     etsApprovalHistoryExists: entity.etsApprovalHistoryExists === undefined || entity.etsApprovalHistoryExists === null ? false : entity.etsApprovalHistoryExists,
//     // approvalStatus: {},
//     approvalHistory: { data: [], isOpen: false },
//     ...requestStatusStrategy(entity)
//   })
// })
//
// const settingsSchema    = new schema.Entity('settings', {}, { idAttribute: 'orgId', processStrategy: requestStatusStrategy })

const ssdMetaDataSchema = new schema.Entity('metaData', {}, { idAttribute: 'ssdMaterialCd' })
const allowedSSDMaterialCodesSchema = new schema.Entity(
  'allowedTestSSDMaterialCodes',
  {},
  { idAttribute: 'testCd' }
)

const nonStockedApprovalRequestsSchema = new schema.Entity(
  'approvalRequests',
  {},
  {
    idAttribute: APPROVAL_REQUEST_CONFIG[ARTYPE_NONSTOCKEDSSD].idField,
    processStrategy: entity => ({
      statusSortOrder: ETS_STATUS_SORT_ORDER[entity.etsApprovalStatus],
      ...entity,
    }),
  }
)
const ancillaryMaterialsApprovalRequestsSchema = new schema.Entity(
  'approvalRequests',
  {},
  {
    idAttribute: APPROVAL_REQUEST_CONFIG[ARTYPE_ANCILLARYMATERIALS].idField,
    processStrategy: entity => ({
      statusSortOrder: ETS_STATUS_SORT_ORDER[entity.etsApprovalStatus],
      materialsDescription:
        entity.specialOrderType === SPECIAL_ORDER_TYPE_SECURE
          ? sortColumnByKey(entity.items, 'description', 'asc')
              .map(item => item.description)
              .join(', ')
          : entity.description,
      ...entity,
    }),
  }
)
const exceptionTestingApprovalRequestsSchema = new schema.Entity(
  'approvalRequests',
  {},
  {
    idAttribute: APPROVAL_REQUEST_CONFIG[ARTYPE_EXCEPTIONTESTING].idField,
    processStrategy: entity => ({
      statusSortOrder: ETS_STATUS_SORT_ORDER[entity.etsApprovalStatus],
      ...entity,
    }),
  }
)
const offCycleTestingApprovalRequestsSchema = new schema.Entity(
  'approvalRequests',
  {},
  {
    idAttribute: APPROVAL_REQUEST_CONFIG[ARTYPE_OFFCYCLETESTING].idField,
    processStrategy: entity => ({
      statusSortOrder: ETS_STATUS_SORT_ORDER[entity.etsApprovalStatus],
      ...entity,
    }),
  }
)
const ordersAfterDeadlineApprovalRequestsSchema = new schema.Entity(
  'approvalRequests',
  {},
  {
    idAttribute: APPROVAL_REQUEST_CONFIG[ARTYPE_ORDERSAFTERDEADLINE].idField,
    processStrategy: entity => ({
      statusSortOrder: ETS_STATUS_SORT_ORDER[entity.etsApprovalStatus],
      ...entity,
    }),
  }
)
const reshipmentsApprovalRequestsSchema = new schema.Entity(
  'approvalRequests',
  {},
  {
    idAttribute: APPROVAL_REQUEST_CONFIG[ARTYPE_RESHIPMENTS].idField,
    processStrategy: entity => ({
      statusSortOrder: ETS_STATUS_SORT_ORDER[entity.etsApprovalStatus],
      apOrderId: entity.apOrderId || null,
      ...entity,
    }),
  }
)
const reshipmentsSchema = new schema.Entity(
  'items',
  {},
  {
    idAttribute: 'ancillaryCd',
  }
)
// const studentSchema = new schema.Entity('students', { sections: [enrollmentSchema] }, {
//   idAttribute: 'studentId',
//   processStrategy: entity => ({
//     sortableStudentName: `${entity.lastName}, ${entity.firstName}`,
//     studentName: `${entity.firstName} ${entity.lastName}`,
//     ...requestStatusStrategy(entity)
//   })
// })

export const normalizeNonStockedApprovalRequests = data =>
  normalize(data, [nonStockedApprovalRequestsSchema])
export const normalizeAncillaryMaterialsApprovalRequests = data =>
  normalize(data, [ancillaryMaterialsApprovalRequestsSchema])
export const normalizeExceptionTestingApprovalRequests = data =>
  normalize(data, [exceptionTestingApprovalRequestsSchema])
export const normalizeOffCycleTestingApprovalRequests = data =>
  normalize(data, [offCycleTestingApprovalRequestsSchema])
export const normalizeOrdersAfterDeadlineApprovalRequests = data =>
  normalize(data, [ordersAfterDeadlineApprovalRequestsSchema])
export const normalizeReshipmentsApprovalRequests = data =>
  normalize(data, [reshipmentsApprovalRequestsSchema])
export const normalizeReshipments = data => normalize(data, [reshipmentsSchema])
// export const denormalizeCourses = ({result: {courses}, entities}) => denormalize(courses, [courseSchema], entities)
// export const normalizeSection   = data => normalize(data, sectionSchema)
//
// export const normalizeStudents    = data => normalize(data, {students: [studentSchema]})
// export const normalizeStudent     = data => normalize(data, studentSchema)
export const denormalizeNonStockedApprovalRequests = ({ result, entities }) =>
  denormalize(result, [nonStockedApprovalRequestsSchema], entities)
export const denormalizeAncillaryMaterialsApprovalRequests = ({ result, entities }) =>
  denormalize(result, [ancillaryMaterialsApprovalRequestsSchema], entities)
export const denormalizeExceptionTestingApprovalRequests = ({ result, entities }) =>
  denormalize(result, [exceptionTestingApprovalRequestsSchema], entities)
export const denormalizeOffCycleTestingApprovalRequests = ({ result, entities }) =>
  denormalize(result, [offCycleTestingApprovalRequestsSchema], entities)
export const denormalizeOrdersAfterDeadlineApprovalRequests = ({ result, entities }) =>
  denormalize(result, [ordersAfterDeadlineApprovalRequestsSchema], entities)
export const denormalizeReshipmentsApprovalRequests = ({ result, entities }) =>
  denormalize(result, [reshipmentsApprovalRequestsSchema], entities)
export const denormalizeRehsipments = ({ result, entities }) =>
  denormalize(result, [reshipmentsSchema], entities)
// export const normalizeEnrollments = data => normalize(data, [enrollmentSchema])
// export const normalizeEnrollment  = data => normalize(data, enrollmentSchema)
//
// export const normalizeOrgSettings = data => normalize(data, settingsSchema)

export const normalizeSSDMaterials = data => ({
  metaData: normalize(data.metaData, [ssdMetaDataSchema]).entities.metaData,
  allowedTestSSDMaterialCodes: normalize(data.allowedTestSSDMaterialCodes, [
    allowedSSDMaterialCodesSchema,
  ]).entities.allowedTestSSDMaterialCodes,
})
